const callouts = [
  // {
  //   id: 1,
  //   active: true,
  //   name: 'دوره نیمه خصوصی شیپ آپ',
  //   nameEn: 'Shape up 9',
  //   description: 'دوره کامل تغذیه و ورزش',
  //   descriptionColor: 'gold',
  //   date: 'شروع دوره -دی ۱۴۰۳',
  //   price: '150',
  //   currency: 'EUR',
  //   paymantUrl: '/signup',
  //   sign: '€',
  //   priceRial: '6000000',
  //   priceRialSign: '۶،۰۰۰،۰۰۰',
  //   period: 'دوره سه ماهه',
  //   imageSrc: require('../img/azi.jpg'),
  //   href: '/shapeup',
  // },
  {
    id: 2,
    active: true,
    name: 'آکادمی شیپ آپ',
    nameEn: 'Shape up Academy',
    description: 'دوره کامل تغذیه ',
    descriptionColor: 'gold',
    date: 'شروع دوره از ۱ اسفند ۱۴۰۲',
    price: '70',
    currency: 'EUR',
    paymantUrl: '/signup',
    sign: '€',
    priceRial: '3499000',
    priceRialSign: '۳،۴۹۹،۰۰۰',
    period: 'نامحدود',
    imageSrc: require('../img/academy.png'),
    href: '/academy',
  },
  {
    id: 3,
    active: true,
    name: 'جلسات اختصاصی کوچینگ تغذیه',
    nameEn: 'Nutrition coaching',
    product_id: 'price_1MqZzJAB6MVrXxqzsXY6cSv3',
    description: ' به همراه اپلیکیشن ورزشی',
    descriptionColor: 'gold',

    price: '189.99',
    priceRial: '10000000',
    priceRialSign: '۱۰،۰۰۰،۰۰۰',
    paymantUrl: 'https://buy.stripe.com/fZebJYanGcVE9IQbJ6',
    currency: 'EUR',
    sign: '€',

    period: 'ماهیانه',
    features: [
      {
        id: 1,
        details: 'چهار جلسه خصوصی آنلاین از طریق ویدیو کال',
      },
      {
        id: 2,
        details: 'مشاوره تغذیه و لایف استایل اختصاصی',
      },
      {
        id: 3,
        details: 'ارسال پیام به پشتیبان از طریق اپلیکیشن  ',
      },
      {
        id: 4,
        details: 'ثبت وزن، دور کمر و دور باسن و مشاهده پیشرفت',
      },
      {
        id: 5,
        details: 'محاسبه BMI و مشاهده پیشرفت    ',
      },
      {
        id: 6,
        details: 'آپدیت ماهیانه تمرین ها بصورت اتوماتیک',
      },
      {
        id: 7,
        details: 'امکان جایگزینی تمرین ها',
      },
      {
        id: 8,
        details: 'تمرینهای متناسب با خانه و باشکاه',
      },
    ],
    href: '/private',
    imageSrc: require('../img/azar.jpg'),
    imageAlt: '',
  },
  {
    id: 4,
    active: true,
    name: ' یک جلسه مشاوره',
    nameEn: 'Single session',
    description: '   یک جلسه مشاوره تغذیه و لایف استایل',
    descriptionColor: 'gold',
    //date: 'شروع دوره -دی ۱۴۰۳',
    price: '47',
    currency: 'EUR',
    paymantUrl: '/signup',
    sign: '€',
    priceRial: '6000000',
    priceRialSign: '۲،۵۰۰،۰۰۰',
    //period: 'دوره سه ماهه',
    imageSrc: require('../img/azi.jpg'),
    href: '/shapeup',
  },
];

export default callouts;
